import { LoadingOutlined } from "@ant-design/icons";
import {
  Disclosure,
  DisclosureButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { useUserActions } from "_actions";
import { API_URL, cx, statesAndUTsOfIndia, titleCase } from "_lib/utils";
import { UserAtom } from "_states";
import { Button, Form, Input, message, Modal, Select, Spin, Table } from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";
import { ChevronDown, Edit2Icon, LogOutIcon, MenuIcon, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";

export const AdminPage = () => {
  const baseUrl = `${API_URL}`;
  const user = useRecoilValue(UserAtom);
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [searchText, setSearchText] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(true);
  const userActions = useUserActions();
  const [form] = useForm();

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = () => {
    axios
      .get(`${baseUrl}/admin/users`, {
        headers: { "X-Token": user.token },
      })
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        console.error(err);
        message.error("Failed to fetch users");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const showUser = (record: any) => {
    setSelectedUser(record);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSearch = (key: any, value: any) => {
    setSearchText((prev: any) => ({ ...prev, [key]: value }));
  };

  const filteredData = users.filter((item: any) => {
    return Object.keys(item).every((key: any) => {
      const searchVal = searchText[key] || "";
      const itemVal = item[key];
      if (itemVal === null || itemVal === undefined) {
        return searchVal === "";
      }
      if (typeof itemVal === "number") {
        return itemVal.toString().includes(searchVal);
      }

      return itemVal.toString().toLowerCase().includes(searchVal.toLowerCase());
    });
  });

  const getTitle = (obj: any) => {
    if (obj.showFilter) {
      return (
        <div>
          <div className={cx(obj.style, "whitespace-nowrap")}>
            {obj.displayName}
          </div>
          <Input
            size="small"
            placeholder="search"
            value={searchText[obj.value]}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => handleSearch(obj.value, e.target.value)}
          />
        </div>
      );
    }
    return <div className={obj.style}>{obj.displayName}</div>;
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <Spin indicator={<LoadingOutlined spin />} size="large" />
      </div>
    );
  }
  return (
    <>
      {/* Navbar */}
      <Disclosure as="nav" className="bg-white shadow-sm fixed w-full z-10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Link to="/">
                  <img
                    alt="Capricorn Mindframe"
                    src={process.env.PUBLIC_URL + "/logo.svg"}
                    className="h-16 w-32"
                  />
                </Link>
              </div>
              <div className="hidden md:block">
                <div className="ml-10 flex items-baseline space-x-4">
                  {/* <NavLink
                    to={"/admin"}
                    className={({ isActive }) =>
                      cx(
                        isActive ? "font-semibold !underline" : "",
                        "text-black rounded-md px-3 py-2 text-sm font-medium"
                      )
                    }
                  >
                    Users
                  </NavLink> */}
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <div className="ml-4 flex items-center md:ml-6">
                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3">
                  <div>
                    <MenuButton className="relative flex max-w-xs items-center rounded-full text-sm font-medium">
                      <span className="absolute -inset-1.5" />
                      <span className="sr-only">Open user menu</span>
                      Admin
                      <ChevronDown className="h-5 w-5" />
                    </MenuButton>
                  </div>
                  <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                  >
                    <MenuItem>
                      <a
                        onClick={userActions.logout}
                        className="flex items-center px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none"
                      >
                        <LogOutIcon className="h-4" />
                        Sign out
                      </a>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </div>
            <div className="-mr-2 flex md:hidden">
              {/* Mobile menu button */}
              <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open main menu</span>
                <MenuIcon
                  aria-hidden="true"
                  className="block h-6 w-6 group-data-[open]:hidden"
                />
                <X
                  aria-hidden="true"
                  className="hidden h-6 w-6 group-data-[open]:block"
                />
              </DisclosureButton>
            </div>
          </div>
        </div>
      </Disclosure>
      {/* Navbar Ends */}

      <section className="max-w-7xl mx-auto space-y-5 py-24 px-4">
        <div className="flex gap-8 bg-white rounded-lg p-4">
          <Table
            className="w-full"
            showHeader={true}
            columns={[
              {
                title: getTitle({
                  displayName: "First Name",
                  value: "firstName",
                  showFilter: true,
                  style: "text-center",
                }),
                dataIndex: "firstName",
                key: "firstName",
              },
              {
                title: getTitle({
                  displayName: "Last Name",
                  value: "lastName",
                  showFilter: true,
                  style: "text-center",
                }),
                dataIndex: "lastName",
                key: "lastName",
              },
              {
                title: getTitle({
                  displayName: "Email",
                  value: "email",
                  showFilter: true,
                  style: "text-center",
                }),
                dataIndex: "email",
                key: "email",
              },
              {
                title: getTitle({
                  displayName: "Mobile",
                  value: "mobile",
                  showFilter: true,
                  style: "text-center",
                }),
                dataIndex: "mobile",
                key: "mobile",
              },
              {
                title: getTitle({
                  displayName: "City",
                  value: "city",
                  showFilter: true,
                  style: "text-center",
                }),
                dataIndex: "city",
                key: "city",
              },
              {
                title: "Active",
                dataIndex: "isActive",
                key: "isActive",
                sorter: (a: boolean, b: boolean) => (a ? 1 : -1),
                render: (isActive) => (isActive ? "Yes" : "No"),
              },
              {
                title: "Action",
                key: "action",

                render: (text, record: any) => (
                  <div className="flex">
                    <Button type="link" onClick={() => showUser(record)}>
                      <Edit2Icon className="text-blue`-500 h-5" />
                    </Button>
                    {/* <Button type="link" onClick={() => showUser(record)}>
                      <RectangleEllipsisIcon className="text-blue`-500 h-5" />
                    </Button> */}
                  </div>
                ),
              },
            ]}
            dataSource={filteredData}
          />
        </div>
      </section>
      <Modal
        title="Basic Modal"
        open={isModalOpen}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <Form
          form={form}
          name="userForm"
          className="py-4"
          layout="horizontal"
          wrapperCol={{ span: 14 }}
          labelCol={{ span: 8 }}
          initialValues={selectedUser}
          onFinish={(values) => {
            axios
              .put(`${baseUrl}/admin/user`, values, {
                headers: { "X-Token": user.token },
              })
              .then((res) => {
                message.success("User updated successfully");
                loadUsers();
                handleCancel();
              })
              .catch((err) => {
                console.error(err);
                message.error("Failed to update user");
              });
          }}
        >
          <Form.Item name={"id"} hidden>
            <Input readOnly />
          </Form.Item>
          <Form.Item
            name={"firstName"}
            label="First Name"
            normalize={(value) => titleCase(value)}
            rules={[
              {
                required: true,
                message: "First Name is required",
                type: "string",
              },
            ]}
          >
            <Input placeholder="First Name" />
          </Form.Item>
          <Form.Item
            name={"lastName"}
            label="Last Name"
            normalize={(value) => titleCase(value)}
            rules={[
              {
                message: "Last Name is required",
                type: "string",
              },
            ]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>
          <Form.Item
            name={"email"}
            label="Email Address"
            rules={[
              {
                required: true,
                message: "Email Address is required",
              },
              {
                type: "email",
                message: "Invalid Email Address",
              },
            ]}
          >
            <Input placeholder="Email Address" type="email" />
          </Form.Item>
          <Form.Item
            name={"mobile"}
            label="Mobile Number"
            normalize={(value) => value.replace(/\D/g, "")}
            rules={[
              {
                pattern: /^[0-9]+$/,
                message: "Mobile Number should contain only digits",
              },
              {
                len: 10,
                message: "Mobile Number should be 10 digits",
              },
            ]}
          >
            <Input placeholder="Mobile Number" prefix="+91 - " />
          </Form.Item>
          <Form.Item
            name={"address1"}
            label="Address Line 1"
            rules={[
              {
                message: "Address line 1 is required",
                type: "string",
              },
              {
                max: 100,
                message: "Address should be less than 100 characters",
              },
            ]}
          >
            <Input placeholder="Address Line 1" />
          </Form.Item>
          <Form.Item
            name={"address2"}
            label="Address Line 2"
            rules={[
              {
                required: false,
                type: "string",
              },
              {
                max: 100,
                message: "Address should be less than 100 characters",
              },
            ]}
          >
            <Input placeholder="Address Line 2" />
          </Form.Item>
          <Form.Item
            name={"city"}
            label="City"
            normalize={(value) => titleCase(value)}
            rules={[
              {
                message: "City is required",
                type: "string",
              },
              {
                max: 50,
                message: "City should be less than 50 characters",
              },
              {
                pattern: /^[a-zA-Z\s]+$/,
                message: "City should contain only alphabets",
              },
            ]}
          >
            <Input placeholder="City" />
          </Form.Item>
          <Form.Item
            name={"state"}
            label="State"
            rules={[
              {
                message: "State is required",
                type: "string",
              },
            ]}
          >
            <Select placeholder="Select State or Union Territory">
              {statesAndUTsOfIndia.map((stateOrUT) => (
                <Select.Option key={stateOrUT} value={stateOrUT}>
                  {stateOrUT}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={"company"}
            label="Company"
            normalize={(value) => titleCase(value)}
            rules={[
              {
                message: "Company is required",
                type: "string",
              },
            ]}
          >
            <Input placeholder="Company" />
          </Form.Item>
          <Form.Item
            name={"designation"}
            label="Designation"
            normalize={(value) => titleCase(value)}
            rules={[
              {
                message: "Designation is required",
                type: "string",
              },
            ]}
          >
            <Input placeholder="Designation" />
          </Form.Item>
          <Form.Item
            name={"pan"}
            label="PAN"
            normalize={(value) => value.toUpperCase()}
            rules={[
              {
                message: "PAN is required",
                type: "string",
              },
              {
                pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: "Invalid PAN format",
              },
              {
                max: 10,
              },
            ]}
          >
            <Input placeholder="PAN" maxLength={10} />
          </Form.Item>
          <Form.Item
            name={"aadhaar"}
            label="Aadhaar Number"
            rules={[
              {
                message: "Aadhaar Number is required",
                type: "string",
              },
              {
                pattern: /^[0-9]{12}$/,
                message: "Aadhaar Number should be 12 digits",
              },
              {
                max: 12,
              },
            ]}
          >
            <Input placeholder="Aadhaar Number" max={12} maxLength={12} />
          </Form.Item>
          <Form.Item
            name={"isActive"}
            label="Is Active"
            rules={[
              {
                type: "boolean",
              },
            ]}
          >
            <Select placeholder="Select State or Union Territory">
              <Select.Option value={true}>Yes</Select.Option>
              <Select.Option value={false}>No</Select.Option>
            </Select>
          </Form.Item>
          <div className="flex flex-row gap-2 w-full justify-end pt-4">
            <Button onClick={handleCancel}>Close</Button>
            <Button type="primary" htmlType="submit">
              Update Profile
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
